import { Path } from '@softline/core';
import { Filter } from '../types/filter';

/** The filter tree without every node on `field`; groups left with one child collapse, empty ones vanish. */
export function withoutField<T extends object>(filter: Filter<T> | null, field: Path<T>): Filter<T> | null {
  if (!filter) return null;
  if (filter.type !== 'conditions') return filter.field === field ? null : filter;
  const filters = filter.filters.map((o) => withoutField(o, field)).filter((o): o is Filter<T> => o !== null);
  if (filters.length === 0) return null;
  if (filters.length === 1) return filters[0];
  return { ...filter, filters };
}
